module.exports = __webpack_public_path__ + "static/media/IMG_20240517_145105.22e1b774.jpg";